<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Matching Gift</span>
</mat-toolbar> -->
<div class="mobile-action-bar">
    <div class="action-mobile-button warn-button" (click)="toHome()"
        color="warn">Cancel</div>
    <div class="action-mobile-button secondary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()"
        color="primary">Save</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()"
        color="primary">Submit</div>
    <div class="action-mobile-button warn-button" *ngIf="!isReadOnly &&
        isApprover"
        (click)="onApproveRejectWithDrawn('Rejected')" color="warn">Reject</div>
    <div class="action-mobile-button primary-button" *ngIf="!isReadOnly &&
        isApprover"
        (click)="onApproveRejectWithDrawn('Approved')"
        color="primary">Approve</div>
</div>

<div  autoscroll="true" class="content">

    <form [formGroup]="mgForm" (keydown.enter)="$event.preventDefault()"
        class="form-content"
        enctype="multipart/form-data">
        <!-- <mat-card fxLayout="column" [fxShow.sm]="false" [fxShow.xs]="false">
            <mat-card-subtitle class="leading-9">
                <p style="color:red;">
                    <b>*NOTE :</b> UP TO $3,000 REQUIRES DIRECTOR/GENERAL MANAGER APPROVAL; $3,000 TO $50,000 REQUIRES
                    VP/OFFICER APPROVAL; $50,000 AND ABOVE REQUIRES PRESIDENT/CEO APPROVAL.
                </p>
                <p>
                    CORPORATE RESPONSIBILITY & COMMUNITY AFFAIRS AND ACCOUNTS PAYABLE WILL NOT PROCESS ANY CONTRIBUTION
                    REQUEST WITHOUT REQUIRED APPROVALS.
                </p>
                <p>
                    FOR MORE INFORMATION SEE POLICY:
                    <a href="https://teams.sp.lgeenergy.int/sites/peoplelink/_layouts/15/WopiFrame.aspx?sourcedoc=/sites/peoplelink/Archive%20Policies/Community%20Investments.docx&action=default&DefaultItemOpen=1"
                        target="_blank">Community Investments (Non-Foundation) and Sponsorships</a>
                </p>
                <p>
                    <a href="https://teams.sp.lgeenergy.int/sites/ITTrainingHub/SitePages/Product%20Page.aspx?ProductFamily=Contributions/Grant Software&Product=Contributions/Grant Software"
                        target="_blank">General Instructions & Job Aids</a>
                </p>
                <p>
                    <b>*</b> = Mandatory
                </p>
            </mat-card-subtitle>
        </mat-card> -->
        <mat-card formGroupName="OrgInfo" fxLayout="column">
            <mat-card-subtitle>
                <b>Organization Information</b>
                <p> Please edit the mailing address below if needed.</p>
            </mat-card-subtitle>
            <mat-form-field>
                <input type="text" EIN matInput placeholder="EIN"
                    maxlength="10" formControlName="EIN"
                    [readonly]='isReadOnly'>
                <button mat-button matSuffix mat-mini-fab aria-label="Validate
                    EIN" color="primary"
                    (click)="onValidateEIN()" [disabled]="isReadOnly ||
                    mgForm.get(['OrgInfo','EIN']).invalid">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field *ngIf="isEINValidated">
                <input type="text" matInput placeholder="Organization Name *"
                    [readonly]='isReadOnly || isMaxLength'
                    [attr.maxlength]="isMaxLength?
                    mgForm.get(['OrgInfo','name']).value.length : 32"
                    formControlName="name" readonly>
                <mat-hint *ngIf="isMaxLength" style="color:red">The organization
                    name has exceeded the max length
                    allowed by current system. Please provide a new name in the
                    "Payable To" field.</mat-hint>
            </mat-form-field>

            <!-- <mat-checkbox class="example-margin">The "Pay to" name is different than the Org Name</mat-checkbox> -->
            <!-- <mat-card fxLayout="column" fxLayoutGap="5px"> -->
            <div style="margin-bottom: 10px" *ngIf="isEINValidated">
                <mat-card-subtitle>Is "Payable To" name different than the
                    Organization Name? *</mat-card-subtitle>
                <mat-radio-group formControlName="payToOption"
                    [disabled]='isReadOnly || isMaxLength'>
                    <mat-radio-button color="primary" value="Yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="No">No</mat-radio-button>
                </mat-radio-group>
            </div>
            <mat-form-field *ngIf="mgForm.get(['OrgInfo','payToOption']).value
                == 'Yes' && isEINValidated">
                <input type="text" matInput placeholder="Payable To *"
                    maxlength="32" formControlName="payTo"
                    [readonly]='isReadOnly'>
            </mat-form-field>
            <!-- </mat-card> -->


            <!-- <mat-form-field *ngIf="isEINValidated">
                    <input type="text" matInput placeholder="EIN *" maxlength="10" formControlName="EIN" readonly>
                </mat-form-field> -->
            <mat-form-field *ngIf="isEINValidated">
                <input type="text" matInput placeholder="Address1 *"
                    maxlength="32" formControlName="address1"
                    [readonly]='isReadOnly'>
                <mat-hint
                    *ngIf="mgForm.get(['OrgInfo','address1']).value.length>
                    32" style="color:red">Address 1 has
                    exceeded the max length
                    allowed. Character count
                    {{mgForm.get(['OrgInfo','address1']).value.length}}/32</mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="isEINValidated">
                <input type="text" matInput placeholder="Address2"
                    maxlength="32" formControlName="address2"
                    [readonly]='isReadOnly'>
                <mat-hint
                    *ngIf="mgForm.get(['OrgInfo','address2']).value.length>
                    32" style="color:red">Address 2 has
                    exceeded the max length
                    allowed. Character count
                    {{mgForm.get(['OrgInfo','address2']).value.length}}/32</mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="isEINValidated">
                <input type="text" matInput placeholder="City *" maxlength="25"
                    formControlName="city"
                    [readonly]='isReadOnly'>
                <mat-hint *ngIf="mgForm.get(['OrgInfo','city']).value.length>
                    32" style="color:red">City has exceeded
                    the max length
                    allowed. Character count
                    {{mgForm.get(['OrgInfo','city']).value.length}}/32</mat-hint>
            </mat-form-field>
            <mat-form-field *ngIf="isEINValidated">
                <mat-select placeholder="State *" formControlName="state"
                    [disabled]='isReadOnly'>
                    <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="isEINValidated">
                <input type="text" matInput placeholder="Zip Code *"
                    maxlength="5" formControlName="zipCode"
                    [readonly]='isReadOnly'>
            </mat-form-field>
            <mat-form-field *ngIf="isEINValidated">
                <input type="text" matInput placeholder="Tax-Exempt Status"
                    maxlength="15"
                    [value]="getTaxExemptStatus(mgForm.get(['OrgInfo','subsection']).value)"
                    readonly>
            </mat-form-field>
            <mat-form-field *ngIf='hasRole(" DEV")&& isEINValidated'>
                <mat-select placeholder="Tax Exempt Status *"
                    formControlName="subsection">
                    <mat-option *ngFor="let subsection of taxExcemptList"
                        [value]="subsection">
                        {{getTaxExemptStatus(subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>

        <mat-card formGroupName="DonorInfo">
            <mat-card-subtitle>
                <b> Donor Information:</b>
            </mat-card-subtitle>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="Employee Id"
                        maxlength="7" formControlName="EmpId"
                        [attr.disabled]='isReadOnly'>
                    <button matSuffix mat-mini-fab aria-label="Validate
                        Employee" color="primary"
                        [disabled]="isReadOnly" (click)="searchEmpById()">
                        <mat-icon>search</mat-icon>
                    </button>
                    <mat-hint>E123456 / N123456</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="Job Title"
                        maxlength="50" formControlName="title"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="Department"
                        maxlength="6" formControlName="department"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="First Name *"
                        maxlength="20" formControlName="firstName"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input type="text" matInput placeholder="Last Name *"
                        maxlength="20" formControlName="lastName"
                        [attr.disabled]='isReadOnly'>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <input type="text" phone matInput placeholder="Phone Number"
                        maxlength="15" formControlName="phone"
                        [attr.disabled]='isReadOnly'>
                    <mat-hint>Example: XXX-XXX-XXXX</mat-hint>
                </mat-form-field>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-card-subtitle>
                    Employment Status:
                </mat-card-subtitle>
                <mat-radio-group formControlName="empStatus"
                    [disabled]='isReadOnly'>
                    <mat-radio-button color="primary" value="FT">Full-Time</mat-radio-button>
                    <mat-radio-button color="primary" value="PT">Part-Time</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <mat-select placeholder="Company *"
                        formControlName="company" [disabled]='isReadOnly'>
                        <mat-option *ngFor="let company of companies"
                            [value]="company">{{company}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-subtitle>
                Payment Method *:
            </mat-card-subtitle>
            <mat-radio-group formControlName="payment" [disabled]='isReadOnly'>
                <mat-radio-button color="primary" value="CHECK">Check</mat-radio-button>
                <mat-radio-button color="primary" value="CREDIT">Credit Card</mat-radio-button>
            </mat-radio-group>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>
                Donation Vehicle:
            </mat-card-subtitle>
            <mat-radio-group formControlName="donationVehicle"
                [disabled]='isReadOnly'>
                <mat-radio-button color="primary" value="CHECK">Check</mat-radio-button>
                <mat-radio-button color="primary" value="SECURITIES">Securities/Stock</mat-radio-button>
            </mat-radio-group>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-form-field>
                <input [attr.disabled]='isReadOnly' placeholder="Amount of Gift"
                    maxlength="10" formControlName="amount"
                    matInput type="text">
                <span matPrefix>$&nbsp;</span>
            </mat-form-field>
        </mat-card>
        <mat-card>
            <mat-form-field>
                <input matInput [matDatepicker]="picker1" readonly
                    placeholder="Date of Gift *"
                    formControlName="giftDate">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-hint align="end">choose from dropdown ^</mat-hint>
            </mat-form-field>
        </mat-card>
        <mat-card fxLayout="column">
            <mat-card-subtitle>
                <b>Attachment(s)</b>
            </mat-card-subtitle>
            <mat-card-subtitle>Please upload Matching Gift form
                <b>(PDF Only)*</b>
            </mat-card-subtitle>

            <mat-card-content>
                <!-- <input type="file" accept="application/pdf" #fileInput multiple formControlName="addAttach" [attr.disabled]='!isReadOnly'> -->
                <input [disabled]='isReadOnly' type="file"
                    accept="application/pdf"
                    (change)="onAttachFileChange($event)" #fileInput1 multiple>
                <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                    *ngIf="mgForm.get('attachment')['controls'].length != 0 &&
                    !isReadOnly">
                    <a class="list-item" mat-list-item
                        *ngIf="mgForm.get('attachment')['controls'].length !=
                        0">
                        <mat-icon color="warn" class="icon-cursor" mat-list-icon
                            (click)="reseAttach()">delete_forever
                        </mat-icon>
                        <h4 mat-line style="cursor: default;">
                            <b>Remove all files</b>
                        </h4>
                    </a>
                    <a class="list-item" mat-list-item
                        *ngFor="let file of
                        mgForm.get('attachment')['controls']; let i= index; ">
                        <mat-icon class="icon-cursor" mat-list-icon
                            (click)="removeAttachFile(file.value.attachName)">
                            delete_forever</mat-icon>
                        <h4 mat-line style="cursor: default;">{{i+1}}. {{
                            file.value.attachName }}</h4>
                    </a>
                </mat-nav-list>

                <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                    *ngIf="mgForm.get('attachment')['controls'].length != 0 &&
                    (!isReadOnly || this.hasRole('ADMIN'))">
                    <a class="list-item" mat-list-item
                        *ngIf="mgForm.get('attachment')['controls'].length !=
                        0">
                        <mat-icon class="icon-cursor" mat-list-icon
                            (click)="DownloadAllAttachFile()">move_to_inbox
                        </mat-icon>
                        <h4 mat-line style="cursor: default;">
                            <b>Download all files</b>
                        </h4>
                    </a>
                    <a class="list-item" mat-list-item
                        *ngFor="let file of
                        mgForm.get('attachment')['controls']; let i= index; ">
                        <mat-icon class="icon-cursor" mat-list-icon
                            (click)="DownloadAttachFile(file.value.attachName)">
                            move_to_inbox</mat-icon>
                        <h4 mat-line style="cursor: default;">{{i+1}}. {{
                            file.value.attachName }}</h4>
                    </a>
                </mat-nav-list>
            </mat-card-content>
        </mat-card>

        <div fxLayout="row" [fxShow.xs]="false" [fxShow.sm]="false">
            <!-- <span>
                <mat-icon class="inline-icon" mat-list-icon>short_text</mat-icon>If unable to submit, complete all
                required fields.
            </span> -->
            <!-- <span><h4 mat-line>If unable to submit, complete all required fields.</h4></span> -->
            <!-- <P></P> -->
        </div>

    </form>
</div> <br><br>
<div class="action-bar">
    <div matRipple class="action-button warn-button" (click)="toHome()">Cancel</div>
    <div matRipple class="action-button secondary-button" *ngIf="!isReadOnly &&
        isShowSaveAsDraft"
        (click)="onSaveAsDraft()"
        color="primary">Save as Draft</div>
    <div matRipple class="action-button primary-button" *ngIf="!isReadOnly"
        (click)="onSubmit()"
        color="primary">{{isShowSaveAsDraft?
        'Submit' : 'Save'}}</div>
    <div matRipple class="action-button warn-button" *ngIf="!isReadOnly && isApprover"
        (click)="onApproveRejectWithDrawn('Rejected')"
        color="warn">Reject</div>
    <div matRipple class="action-button primary-button" *ngIf="!isReadOnly &&
        isApprover"
        (click)="onApproveRejectWithDrawn('Approved')"
        color="primary">Approve</div>
    <!-- <button mat-raised-button *ngIf="!isApproved && isShowWithdrawn" (click)="onApproveRejectWithDrawn('Withdrawn')" color="warn">Withdraw</button> -->
</div>